// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"aa926bc9","147":"9fe9b391","156":"1a3b154d","438":"39bbd81a","706":"d45ad11e","726":"cb4264f7"}[chunkId] + ".chunk.js";
};